import { useMutation } from '@tanstack/react-query';
import { addIncidentDocuments, AddIncidentDocumentsRequest } from '../services';

export const useAddIncidentDocuments = () =>
  useMutation<unknown, Error, AddIncidentDocumentsRequest>(
    ['add-incident-documents'],
    addIncidentDocuments,
  );
